import { render, staticRenderFns } from "./PayBlocked.vue?vue&type=template&id=0daf09f6&scoped=true&"
import script from "./PayBlocked.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PayBlocked.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PayBlocked.vue?vue&type=style&index=0&id=0daf09f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf09f6",
  null
  
)

export default component.exports